import config from '../nyConfig'
const ApiArticle = {
    "添加角色": new config({ url: '/manager/addRole', showSuccessMessage: true, useToken: true }),
    "修改角色": new config({ url: '/manager/editRole', showSuccessMessage: true, useToken: true }),
    "角色列表": new config({ url: '/manager/listRole', showSuccessMessage: false, useToken: true }),
    "冻结/解冻角色": new config({ url: '/manager/operateRole', showSuccessMessage: true, useToken: true }),
    "删除角色": new config({ url: '/manager/delRole', showSuccessMessage: true, useToken: true }),
    "添加用户": new config({ url: '/manager/addUser', showSuccessMessage: true, useToken: true }),
    "修改用户": new config({ url: '/manager/editUser', showSuccessMessage: true, useToken: true }),
    "用户列表": new config({ url: '/manager/listUser', showSuccessMessage: false, useToken: true }),
    "冻结/解冻用户": new config({ url: '/manager/operateUser', showSuccessMessage: true, useToken: true }),
    "删除用户": new config({ url: '/manager/delUser', showSuccessMessage: true, useToken: true }),
}

export default ApiArticle